import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 1365 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1365 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\"><path d=\"M597.473 1024H341.557a341.221 341.221 0 01-83.94-672.035 383.874 383.874 0 01764.079-10.408h2.303a341.221 341.221 0 110 682.443H768.083V768.084h170.61L682.779 426.863 426.862 768.084h170.61V1024z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol